import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import { siteConfig } from "../config/siteConfig";

function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__ribbon" aria-hidden="true">
        <span>{siteConfig.tagline}</span>
        <span>{siteConfig.tagline}</span>
        <span>{siteConfig.tagline}</span>
      </div>

      <div className="site-footer__grid">
        <section
          className="site-footer__address"
          aria-labelledby="footer-brand"
        >
          <h2 id="footer-brand">{siteConfig.brandName}</h2>

          <p className="site-footer__label">Opening times</p>
          <p>{siteConfig.contact.openingHours}.</p>
          <p>Email us before visiting so our team can assist you.</p>
        </section>

        <section aria-labelledby="footer-contact">
          <h2 id="footer-contact">Get in touch</h2>

          <p>
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email}
            </a>
          </p>
          <p>{siteConfig.legalName}</p>
          <p>{siteConfig.contact.address}</p>
        </section>

        <nav aria-label="Footer navigation">
          <h2>Information</h2>
          <ul className="site-footer__links">
            <li>
              <Link to="/about" onClick={scrollToTop}>
                About
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={scrollToTop}>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/shipping" onClick={scrollToTop}>
                Shipping
              </Link>
            </li>
            <li>
              <Link to="/returns" onClick={scrollToTop}>
                Returns
              </Link>
            </li>
            <li>
              <Link to="/privacy" onClick={scrollToTop}>
                Privacy policy
              </Link>
            </li>
            <li>
              <Link to="/terms" onClick={scrollToTop}>
                Terms of service
              </Link>
            </li>
            <li>
              <Link to="/faqs" onClick={scrollToTop}>
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/cookies" onClick={scrollToTop}>
                Cookie policy
              </Link>
            </li>
          </ul>
        </nav>

        <section aria-labelledby="footer-payments">
          <h2 id="footer-payments">Secure payments</h2>
          <p>Supported payment methods</p>
          <div
            className="site-footer__payments"
            aria-label="Visa, Mastercard, American Express and Apple Pay"
          >
            <span>VISA</span>
            <span>Mastercard</span>
            <span>AMEX</span>
            <span>Apple Pay</span>
          </div>
        </section>
      </div>

      <div className="site-footer__bottom">
        <span>
          © {new Date().getFullYear()} {siteConfig.legalName}
        </span>
        <button type="button" onClick={scrollToTop}>
          Back to top ↑
        </button>
      </div>
    </footer>
  );
}

export default Footer;
